import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"


const initialState = {
    data: null,
    loading: false,
    error: null,

}

export const getwalkinInterviewList = createAsyncThunk(
    "getwalkinInterviewList",
    async (body) => {
        try {
            const response = await instance.get(`crm/walking-interview/get-all-walkins?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}&experience=${body.experience}`)
            return response.data;
        } catch (error) {
            return error?.response
        }
    }
)


export const WalkinInterviewSlice = createSlice({
    name: "WalkinInterviewSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getwalkinInterviewList.pending, (state) => {
            state.loading = true;
            state.data = null;
        });
        builder.addCase(getwalkinInterviewList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(getwalkinInterviewList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
    }
})

export default WalkinInterviewSlice.reducer;